import {DomainEvent} from './DomainEvent';
import {FollowedEntity} from '../resources/FollowedEntity';

/**
 * Base class for events, that are raised, when a user is following an entity. Derived events are
 * also triggered, if the `push` setting is changed.
 */
export abstract class EntityFollowedEvent extends DomainEvent<FollowedEntity> {}
